module.exports = __webpack_public_path__ + "../resources/images/exemplary-filehub-72fc318aa3fb8a933b80bbbce4e8c7f5.png";